module.exports = __webpack_public_path__ + "img/idx-service-shield.eb09a40.webp";